import api from '@virgodev/bazaar/functions/api';
import dateFormatted from './date_formatted';
import dateFromNow from './date_from_now';
import formatPrice from './format_price';
import goBack from './go_back';
import isElementInViewport from './is_element_in_viewport';
import logUserOut from './log_user_out';
import pluralize from './pluralize';

export default {
  api,
  dateFormatted,
  dateFromNow,
  formatPrice,
  goBack,
  isElementInViewport,
  logUserOut,
  pluralize,
  copy(a) {
    return JSON.parse(JSON.stringify(a));
  },
};
